import { Engine } from "@babylonjs/core/Engines/engine";
import { WebGPUEngine } from "@babylonjs/core/Engines/webgpuEngine";
import { getSceneModule } from "./createScene";
import "@babylonjs/core/Engines/WebGPU/Extensions/engine.uniformBuffer";
export const babylonInit = async () => {
    const createSceneModule = getSceneModule();
    const engineType = location.search.split("engine=")[1]?.split("&")[0] || "webgl";
    // Execute the pretasks, if defined
    await Promise.all(createSceneModule.preTasks || []);
    // Get the canvas element
    const canvas = document.getElementById("renderCanvas");
    // Generate the BABYLON 3D engine
    let engine;
    if (engineType === "webgpu") {
        const webGPUSupported = await WebGPUEngine.IsSupportedAsync;
        if (webGPUSupported) {
            const webgpu = engine = new WebGPUEngine(canvas, {
                adaptToDeviceRatio: true,
                antialias: true,
            });
            await webgpu.initAsync();
            engine = webgpu;
        }
        else {
            engine = new Engine(canvas, true);
        }
    }
    else {
        engine = new Engine(canvas, true);
    }
    // Create the scene
    const scene = await createSceneModule.createScene(engine, canvas);
    // JUST FOR TESTING. Not needed for anything else
    window.scene = scene;
    // Register a render loop to repeatedly render the scene
    engine.runRenderLoop(function () {
        scene.render();
    });
    // Watch for browser/canvas resize events
    window.addEventListener("resize", function () {
        engine.resize();
    });
};
babylonInit().then(() => {
    // scene started rendering, everything is initialized
});
